import { getDictPhrase } from "../../../common";
export const getBetDataProps = (bet, state) => {
    return {
        betIdPhrase: getDictPhrase(state.dict, "BetId"),
        betId: bet.displayId,
        placementPhrase: getDictPhrase(state.dict, "BetPlacement"),
        placement: state.formatDate(bet.placementDate, state.config.currentTimeZone)
    };
};
//# sourceMappingURL=getBetDataProps.js.map